import { render } from "./LoadingSpinnerNr6.vue?vue&type=template&id=3a6b9390&scoped=true"
import script from "./LoadingSpinnerNr6.vue?vue&type=script&lang=js"
export * from "./LoadingSpinnerNr6.vue?vue&type=script&lang=js"

import "./LoadingSpinnerNr6.vue?vue&type=style&index=0&id=3a6b9390&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\c1chy\\Desktop\\vue\\Vue3-Components\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a6b9390"]])

export default __exports__